import * as api from '../api/processEx366';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const PROCESS_EX366 = createRequestTypes(`${prefix}/PROCESS_EX366`);

export const processEx366 = makeApiActionCreatorV3(
  api.processEx366,
  PROCESS_EX366[START],
  PROCESS_EX366[SUCCESS],
  PROCESS_EX366[ERROR],
);

export const FETCH_EX366 = createRequestTypes(`${prefix}/FETCH_EX366`);

export const fetchEx366 = makeApiActionCreatorV3(
  api.fetchEx366,
  FETCH_EX366[START],
  FETCH_EX366[SUCCESS],
  FETCH_EX366[ERROR],
);

export const FETCH_EX366_LISTING = createRequestTypes(
  `${prefix}/FETCH_EX366_LISTING`,
);

export const fetchEx366Listing = makeApiActionCreatorV3(
  api.fetchEx366Listing,
  FETCH_EX366_LISTING[START],
  FETCH_EX366_LISTING[SUCCESS],
  FETCH_EX366_LISTING[ERROR],
);

export const FETCH_EX366_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_EX366_PROPERTIES`,
);

export const fetchEx366Properties = makeApiActionCreatorV3(
  api.fetchEx366Properties,
  FETCH_EX366_PROPERTIES[START],
  FETCH_EX366_PROPERTIES[SUCCESS],
  FETCH_EX366_PROPERTIES[ERROR],
);
